import { Component, OnInit, Inject, Optional } from '@angular/core';
import { Redirection, Shell, BaseComponent, AppConfig, SiteWideAlert } from '@tytaccounts/common';
import { environment } from '@tytaccounts/environments/environment';
import { NoticeService } from '@tytaccounts/common';
import { ApiAppConfig } from 'api';
import { REQUEST, RESPONSE } from '@nguniversal/express-engine/tokens';
import * as express from '../../common/express-ssr';
import { UserService } from 'user';
import { TestDialogComponent } from '../test-dialog/test-dialog.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent extends BaseComponent implements OnInit {

  constructor(
    private redirection : Redirection,
    private shell : Shell,
    private notices : NoticeService,
    private appConfig : AppConfig,
    private userService : UserService,

    @Inject(REQUEST) @Optional()
    public request : express.ExpressRequest,
    @Inject(RESPONSE) @Optional()
    public response : express.ExpressResponse,
  ) {
    super();
   }

  showDev : boolean = false;
  appStatus : ApiAppConfig = null;
  appConfigs : any = null;

  showDialog(name, ...args) {
    this.shell.showDialog(name, ...args);
  }

  alerts : SiteWideAlert[] = [];

  init() {
    let isDev = false;

    this.shell.alertsChanged.subscribe(alerts => this.alerts = alerts);
    this.appConfigs = environment;
    this.subscribe(this.appConfig.appStatusChanged, status => {
      this.appStatus = status;
    });
    
    if (typeof window !== 'undefined' && window.localStorage.developer)
      isDev = true;

    if (!isDev && environment.production) {
      this.redirection.go('/settings/memberships');
    } else {
      this.showDev = true;
    }
  }

  dismissNotices() {
    this.notices.dismissNotices();
  }
  
  postNotice(message, severity) {
    this.notices.post(message, severity);
    this.redirection.go('/dev/test/notice');
  }

  addAlert() {
    this.shell.addAlert({ 
      id: `id_${Math.floor(Math.random() * 1000)}`,
      message: 'This is a message',
      url: 'https://duckduckgo.com/'
    });
  }

  signInToken : string;

  async signInViaToken() {
    try {
      await this.userService.assume(this.signInToken);
      alert(`Signed in.`);
    } catch (e) {
      console.error(e);
      alert(`Caught error [see console]: ${e}`);
    }
  }

  showTestDialog() {
    this.showDialog(TestDialogComponent, 'This is the message that was passed!')
  }

  showTestMessageDialog() { 
    this.shell.alert(`This is the title`, `This is the message`);
  }

  async showTestConfirmDialog() { 
    if (await this.shell.confirm(`This is the title`, `Are you sure?`, { confirmText: 'Yep', cancelText: 'Nope' })) {
      this.shell.alert(`You said yes!`, `A lovely choice.`);
    } else {
      this.shell.alert(`You said no!`, `Please reconsider!`);
    }
  }

}
